module.exports = __webpack_public_path__ + "img/sel_Guangzhou.a42ea83f.jpg";